var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-icon',{attrs:{"left":"","color":"primary","size":"75"}},[_vm._v(" mdi-face-agent ")]),_c('span',{staticClass:"text-overline primary--text"},[_vm._v(" Central de Atendimento ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }